import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap/lib';
import { CLIENT_TYPE } from '@upstart/harmony/lib/constants';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import SidebarContainer from '../SidebarContainer';
import DealerNav from '../../components/DealerNav';
import dealersActions from '../../redux/dealers/actions';

function DealerText({ actions, dealer, match }) {
  useEffect(() => {
    actions.dealerRequest({ dealerId: match.params.dealerId });
  }, [actions, match.params.dealerId]);

  const editColumn = (_, page) => (
    <Link
      className="btn btn-default"
      to={`/${dealer.id}/text/${CLIENT_TYPE.ONLINE}/${page.id}`}
    >
      Edit
    </Link>
  );

  if (!dealer || !dealer.id) {
    return null;
  }

  const pageList = [];

  return (
    <SidebarContainer title={dealer.name} logo={dealer.logo}>
      <div className="dealers-table">
        <DealerNav />
        <div className="dealer-editor-container tabbed-page-container">
          <Tabs id="dealer-text-tabs">
            <Tab eventKey={CLIENT_TYPE.ONLINE} title="Online">
              <h3>{pageList.length} Pages</h3>
              <BootstrapTable
                hover
                condensed
                tableStyle={{ border: 'none' }}
                data={pageList}
              >
                <TableHeaderColumn dataField="name" isKey>
                  Name
                </TableHeaderColumn>
                <TableHeaderColumn dataField="path">Route</TableHeaderColumn>
                <TableHeaderColumn dataField="enabled">
                  Enabled
                </TableHeaderColumn>
                <TableHeaderColumn dataFormat={editColumn} />
              </BootstrapTable>
            </Tab>
          </Tabs>
        </div>
      </div>
    </SidebarContainer>
  );
}

DealerText.propTypes = {
  actions: PropTypes.object,
  dealer: PropTypes.object,
  match: PropTypes.object,
};

const mapStateToProps = ({ dealers }) => ({
  dealer: dealers.dealer,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...dealersActions }, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DealerText),
);
